import React from 'react';
import { Uploader } from '../Uploader/Uploader';
import { withTranslation } from 'react-i18next';
import SearchBar from '../SearchBar/SearchBar';
import FileElement from '../FileElement/FileElement';
import MoreOptionsPopup from '../MoreOptionsPopup/MoreOptionsPopup';
import { callIfMouseSupported, callIfTouchSupported, callIfPointerSupported } from '../General/EventSupport';
import Dialog from '../Dialog/Dialog';
import './FileList.less'

class FileList extends React.Component {

  getFileSortTags() {
    const { t } = this.props;
    return [
      {title: t('SortTagUploadDate'),
        function:
          function(elements){
            elements.sort(function(a, b){
              return new Date(b.Updated) - new Date(a.Updated)
          })
        }},
      {title: t('SortTagUpdateDate'),
          function:
            function(elements){
              elements.sort(function(a, b){
                return new Date(b.Updated) - new Date(a.Updated)
            })
          }},
      {title: t('SortTagName'),
        function:
          function(elements){
            elements.sort((a, b) => {
              let nameA = a ? a.Description.toString().toLowerCase() : "";
              let nameB = b ? b.Description.toString().toLowerCase() : "";
              if (nameA < nameB)
                return -1;
              if (nameA > nameB)
                return 1;
              return 0;
          })
        }},
      {title: t('SortTagInApp'),
        function:
          function(elements){
            elements.sort(function(a, b){
              return (a.InApp === b.InApp)? 0 : a.InApp? -1 : 1;
            })
        }},
      {title: t('SortTagSize'),
        function:
          function(elements){
            elements.sort(function(a, b){
              return b.RawSize - a.RawSize;
            })
        }}
    ];
  }

    static defaultProps = {
      realm: null,
      companyID: null,
      fileSpaces: 5,
      appAccess: false,
      canEdit: false,
      copyLink: function(){},
      onShowQRCode: function(){},
      onUpdateQRCode: function(){},
      onClickOpenModel: function(){},
      onClickJobHistory: function(){},
      onFilesChanged: function(){},
      deleteModel: function(){},
      userFilesData: [],
      modelWarningSize: 1000000, //bytes //=10mb
    };

    closeNoticeTimeout = null;

    constructor(props) {
        super(props);
        let browserWidth = this.getWindowWidth();
        let searchOptions = {sortTag: this.getFileSortTags()[0], filterTag: null, inverted: false};

        this.state = {
          fileSpaces: this.props.fileSpaces,
          appAccess: this.props.appAccess,
          moreOptionsOpen: false,
          modelviewerModel: null,
          activeQrCode: null,
          editModelName: -1,
          tutorialOpen: false,
          debugItem: null, //if ItemID is set here, only the specified element will be shown in list
          noticeSustain: 1500,
          showNotice: false,
          filesSearchOptions: searchOptions,
          browserWidth: browserWidth,
          tempFileName: "",
          filesToRender: this.getRenderFiles(this.props.fileSpaces, searchOptions, browserWidth, null),
          modelWarningSize: this.props.modelWarningSize,
          userFilesData: this.props.userFilesData,
        };
    }

    componentDidMount(){
      window.addEventListener('resize', () => this.setState({browserWidth: this.getWindowWidth()}) , true);
      this.setState({filesToRender: this.getFilesToRender()});
    }

    setEditModelname(idx, newname =""){
        if (!this.props.canEdit) return;
        const filesToRender = this.getRenderFiles(this.state.fileSpaces, this.state.filesSearchOptions, this.state.browserWidth, null);
        if (newname !== ""){
          filesToRender[this.state.editModelName].Description = newname;
          Uploader.updateJobDescription(filesToRender[this.state.editModelName].ItemID, newname);
        }

        var tempname = "";
        if (filesToRender && filesToRender[idx])
          tempname = filesToRender[idx].Description;
        this.setState({editModelName: idx, tempFileName: tempname});
    }

    componentDidUpdate(prevProps, prevState){
      if (prevProps.fileSpaces !== this.props.fileSpaces || prevProps.appAccess !== this.props.appAccess)
      {
        var newlimit = this.props.fileSpaces;
        this.setState({userFilesData: this.props.userFilesData, fileSpaces: newlimit, appAccess: this.props.appAccess});
      }

      else if(prevState.filesSearchOptions !== this.state.filesSearchOptions){
        this.setState({userFilesData: this.props.userFilesData})
      }

      else if(prevProps.userFilesData !== this.props.userFilesData){
        this.setState({userFilesData: this.props.userFilesData})
      }

      else
      {
        var equal = true;
        this.props.userFilesData.forEach((e) =>
          {
            if (this.state.userFilesData == null)
              {
                equal = false;
                return;
              }
            var finding = this.state.userFilesData.find((f) => e.ItemID === f.ItemID);
            if (finding == null)
            {

              equal = false;
              return;
            }
          })

        if (!equal)
          {
              this.setState({userFilesData: this.props.userFilesData})
          }
      }
    }

    setCompany(companyID){
      //open new browser tab
      window.open(this.generateUserLink(companyID)).focus();
    }

    generateModelLink(id){
      if(id){
        if (window.config.host.cdn.includes("vithrough"))
          return "https://viewer.vithrough.com/?id=" + id;
        else
        return window.config.host.cdn + "/" + this.props.realm + "/modelviewer/?id=" + id;
      }else{
        return null
      }
    }

    generateUserLink(id){
      if(id){
        if (window.config.host.cdn.includes("vithrough"))
          return "https://viewer.vithrough.com/?userID=" + id;
        else
        return window.config.host.cdn + "/" + this.props.realm + "/modelviewer/?userID=" + id;
      }else{
        return null
      }
    }

    downloadCompanyQRCode(companyID){
      this.props.onUpdateQRCode(this.generateUserLink(companyID), "models_qr.png");
    }

    downloadModelQRCode(itemID, filename){
      this.props.onUpdateQRCode(this.generateModelLink(itemID), filename);
    }

    updateInAppForModel(ItemID, newVal){
      Uploader.updateJobInApp(ItemID, newVal)
      .then((res)=>{
        this.props.onFilesChanged();
      })
      .catch((err)=>{
        console.error(err);
      })
    }

    updateInAppForUser(newVal){
        let filteredFiles = this.getFilteredFiles(this.state.userFilesData, this.state.filesSearchOptions).map(e => e.ItemID);
        Uploader.updateInAppForUser(this.props.companyID, newVal, filteredFiles)
        .then((res)=>{
          this.props.onFilesChanged();
        })
        .catch((err)=>{
          console.error(err);
        })
    }

    allInApp(){
      const { t } = this.props;
      Dialog.Alert({
          title: t('AllModelsInAppTitle'),
          description: t('AllModelsInAppText'),
          options: [
              {label: t('OK'), className:"dangerConfirm"},
              {label: t('Cancel'), className:""},
          ],
          panelOptions: {className: "vithrough"},
      }).then((optionChosen) => {
          if (optionChosen === 0) {
            this.updateInAppForUser(true);
          }
      })
    }

    noneInApp(){
      const { t } = this.props;
      Dialog.Alert({
          title: t('AllModelsOutAppTitle'),
          description: t('AllModelsOutAppText'),
          options: [
              {label: t('OK'), className:"dangerConfirm"},
              {label: t('Cancel'), className:""},
          ],
          panelOptions: {className: "vithrough"},
      }).then((optionChosen) => {
          if (optionChosen === 0) {
            this.updateInAppForUser(false);
          }
      })
    }

    getFilteredFiles(files, searchOptions){
      if(searchOptions && searchOptions.filterTag && searchOptions.filterTag.function){
        return searchOptions.filterTag.function(files, searchOptions.filterTag.searchText);
      }

      return files;
    }

    getRenderFiles(fileSpaces, filesSearchOptions, browserWidth, debugItem){
      let filesToRender = []

        if(!this.state || !this.state.userFilesData){
            return filesToRender;
        }

        for (let index = 0; index < fileSpaces; index++) {
            if(this.state.userFilesData[index]){
              filesToRender.push(this.state.userFilesData[index]);
            }
        }

        let searchOptions = filesSearchOptions;
        if(searchOptions){
            // --> filter files
            if(searchOptions.filterTag){
              filesToRender = this.getFilteredFiles(filesToRender, searchOptions);
            }
            // --> sort files
            if(searchOptions.sortTag){
            searchOptions.sortTag.function(filesToRender);
              if(searchOptions.inverted){
                  filesToRender.reverse();
              }
            }
        }

        const userFilesLength = this.state.userFilesData.length;
        if(fileSpaces > userFilesLength){
            // --> append empty file spaces
            filesToRender.push({})
        }else{
            // --> add "do you need more space?" element
            filesToRender.push({ItemID: -1});
        }

        if(debugItem){
            filesToRender.length = 0;
            if(this.state.userFilesData){
              this.state.userFilesData.forEach(file => {
                  if(file.ItemID && file.ItemID === debugItem){
                  filesToRender.push(file);
                  }
              });
            }
        }

      return filesToRender;
    }

    getFilesToRender(){
      return this.getRenderFiles(this.state.fileSpaces, this.state.filesSearchOptions, this.state.browserWidth, this.state.debugItem);
    }

    getWindowWidth(){
      if(document){
        if(document.body && document.body.offsetWidth){
          return document.body.offsetWidth;
        }

        if(document.documentElement && document.documentElement.offsetWidth){
          return document.documentElement.offsetWidth;
        }
      }

      if(window && window.innerWidth){
        return window.innerWidth;
      }

      return -1;
    }

    render() {
      const { t } = this.props;
      const props = this.props;
      const state = this.state;
      const fileSortTags = this.getFileSortTags();
      const userFilesCount = props.userFilesData ? props.userFilesData.length : 0;
      const allFiles = props.userFilesData ? props.userFilesData : [];

      const filesSearchOptions = state.filesSearchOptions;
      const filesToRender = this.getRenderFiles(props.fileSpaces, filesSearchOptions, state.browserWidth, null);
      const filteredFiles = this.getFilteredFiles(allFiles, filesSearchOptions);
      const filterActive = filesSearchOptions && filesSearchOptions.filterTag && filesSearchOptions.filterTag.searchText !== "" && filesSearchOptions.filterTag.searchText != null;
      var allFilesNotInApp = filteredFiles.find((e) => e.InApp === 1) == null;
      var allFilesInApp = filteredFiles.find((e) => e.InApp === 0) == null;
      return (
        <div className='user_files_container'>
            <div className='user_files_list_header open'>
                <div className='user_files_list_header_left'>
                  <div id='user_list_circle' className='user_list_circle'/>
                  <label id='Models'>{t('YourModels')}</label>
                </div>
                <div className='user_files_list_header_right'>
                  <label id='Space'>{userFilesCount + "/" + state.fileSpaces + " " + t('SpacesTaken')}</label>
                    <div className='more_options_container'>
                      <div
                        title={t('MoreOptions')}
                        disabled={filterActive}
                        className='armodelviewer_button more_options_button'
                        onPointerUp={(e) => {
                          callIfPointerSupported(() => this.setState({moreOptionsOpen: !state.moreOptionsOpen}), e);
                          e.stopPropagation();
                          e.preventDefault();
                        }}
                        onTouchStart={(e) => {
                          callIfTouchSupported(() => this.setState({moreOptionsOpen: !state.moreOptionsOpen}));
                          e.stopPropagation();
                          e.preventDefault();
                        }}
                        onMouseUp={(e) => {callIfMouseSupported(() => this.setState({moreOptionsOpen: !state.moreOptionsOpen}), e);
                          e.stopPropagation();
                          e.preventDefault();
                        }}
                      >
                        <label>{t('MoreOptions')}</label>
                      </div>
                      <MoreOptionsPopup
                        open={state.moreOptionsOpen}
                        showAllOptions={props.canEdit}
                        allFilesNotInApp={allFilesNotInApp}
                        allFilesInApp={allFilesInApp}
                        filterActive={filterActive}
                        onClickCloseButton={() => {this.setState({moreOptionsOpen: false})}}
                        onClickFirstButton={() => {this.setCompany(props.companyID)}}
                        onClickSecondButton={() => {this.allInApp()}}
                        onClickThirdButton={() => {this.noneInApp()}}
                        onClickFourthButton={() => {props.onClickJobHistory()}}
                      />
                  </div>
                </div>
            </div>
            <div className='user_files_list_container'>
                <SearchBar
                onNewSearchOptions={(options) => {this.setState({filesSearchOptions: options})}}
                sortTags={fileSortTags}
                filterTags={[
                    {title: t('FilterTagName'),
                    function:
                        function(elements, filterText){
                        return elements.filter((elem) => {
                            if(filterText == null || filterText === ""){
                                return true; //if there is nothing to filter against
                            }
                            return elem && (elem.Description && filterText && elem.Description.toString().toLowerCase().indexOf(filterText.toString().toLowerCase()) >= 0);
                        })
                    }},
                ]}
                />
                <div className='user_files_list' id='user_files_list'>
                {userFilesCount > 0 ?
                filesToRender.map((data, idx) => {
                    if(data.ItemID){
                      const itemID = data.ItemID;

                      if(itemID !== -1){
                        const fileTooBig = data.GltfSize > state.modelWarningSize;
                        return (
                          <FileElement
                            data = {data}
                            editModelName = {state.editModelName} //TODO: editModelName kan wahrscheinlich auch direkt im Element stattfinden
                            fileTooBig = {fileTooBig}
                            setEditModelname = {(idx, name) => {this.setEditModelname(idx, name)}}
                            onClick = {(data) => {this.setState({tempFileName : "", editModelName: -1}); props.onClickOpenModel(data)}}
                            appAccess = {state.appAccess}
                            canEdit = {props.canEdit}
                            tempFileName = {state.tempFileName}
                            onChangeTempFileName= {(value) => {this.setState({tempFileName: value})}}
                            copyLink = {() => props.copyLink(itemID)}
                            onShowQRCode = {() => props.onShowQRCode(this.generateModelLink(itemID))}
                            deleteModel = {() => props.deleteModel(itemID)}
                            downloadModelQRCode = {() => this.downloadModelQRCode(itemID, data.Description + "_qr.png")}
                            updateInAppForModel = {(checked) => this.updateInAppForModel(itemID, checked)}
                            fileIndex= {idx}
                            key={"UploadedFileData-" + idx}
                          />)
                        }else{
                          return(
                              filesToRender.length - userFilesCount < 3 &&
                              <div className='user_file_element_getMoreSpace'  key={"UploadedFileData-" + idx}>
                              <label id='more_space'>{t('MoreSpace')}</label>
                              </div>
                          )
                        }
                    }else{
                        return(
                        userFilesCount + 1 > idx &&
                        <div className='user_file_element_empty'  key={"UploadedFileData-" + idx}>
                            <label>{t('EmptySlot')}</label>
                        </div>
                        )
                    }
                })
                :<label>{t('NoModel')}</label>}
                </div>
            </div>
        </div>
        );
    }
}

export default withTranslation()(FileList);
